import {createContext, useContext, useMemo, useState} from 'react'

interface RefraModalContextState {
  modal: React.ReactNode
  openModal: (modalComponent: React.ReactNode) => void
  closeModal: () => void
}

export const RefraModalContext = createContext<RefraModalContextState | undefined>(undefined)

export const useRefraModal = (): RefraModalContextState => {
  const context = useContext(RefraModalContext)
  if (!context) throw new Error('useRefraModal is used outside of the RefraModalProvider!')
  return context
}

export const RefraModalProvider: React.FC<React.PropsWithChildren> = ({children}) => {
  const [modal, setModal] = useState<React.ReactNode>(null)

  const memoizedContextState = useMemo(
    () => ({
      modal,
      openModal: (modalComponent: React.ReactNode) => setModal(modalComponent),
      closeModal: () => setModal(null)
    }),
    [modal]
  )

  return (
    <RefraModalContext.Provider value={memoizedContextState}>{children}</RefraModalContext.Provider>
  )
}
